import { useLayoutEffect, useMemo, useRef, useState } from "react";
import { motion } from "framer-motion";
import VideoSectionSectionData from "./VideoSectionSectionData";
import VideoControls from "./VideoControls";
import useVideoScreenLogic from "./useVideoScreenLogic";

const DESKTOP_HEIGHT = 450;

const VideoScreen = () => {
  const videoRef = useRef(null);

  // מודדים את הרוחב הזמין כדי שה-frame לא יחרוג כשמצמצמים חלון
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  // יחס וידאו אמיתי (יתעדכן ב-onLoadedMetadata)
  const [aspect, setAspect] = useState(9 / 16);

  const data = useMemo(() => {
    const items = Array.isArray(VideoSectionSectionData)
      ? VideoSectionSectionData
      : [];
    return items.filter((it) => it && it.type === "video");
  }, []);

  const {
    index,
    current,
    isMobile,
    isVisible,
    isPlaying,
    isMuted,
    requiresUserRestartForSound,

    goNext,
    goPrev,
    togglePlayPause,
    toggleMute,

    onSwipeNext,
    onSwipePrev,

    markInteractionThatShouldEnableSound,
    bindVisibilityToElement,
  } = useVideoScreenLogic({ data, videoRef });

  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect?.width;
      if (typeof w === "number") setContainerWidth(w);
    });

    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  if (!current) return null;

  const dragEnabled = Boolean(isMobile);

  const wrapperClass = isMobile
    ? "videoSectionInner"
    : "videoSectionInner videoSectionInnerWide";

  const desiredDesktopWidth = Math.round(DESKTOP_HEIGHT * aspect);

  // בדסקטופ: גובה קבוע, רוחב נגזר מהגובה אך לא חורג מהקונטיינר
  const computedFrameWidth = isMobile
    ? "100%"
    : `${Math.min(desiredDesktopWidth, containerWidth || desiredDesktopWidth)}px`;

  const frameStyle = {
    height: isMobile ? "auto" : `${DESKTOP_HEIGHT}px`,
    width: computedFrameWidth,
    position: "relative",
    overflow: "hidden",
    borderRadius: "22px",
    touchAction: dragEnabled ? "pan-y" : "auto",
  };

const NewHeadline = 
<div className={`reelSectionMainText ${isMobile ? "mb-s-10" : ""}`}>
        <h2 className="color-blue-dark">רילסים אחרונים</h2>
        <h5 className="color-blue-dark">קטעים נבחרים בתנועה</h5>
      </div>

{/* <div>
  <p className="newVideoHeadline">NewHeadline</p>
</div> */}

  return (
    <div
      ref={bindVisibilityToElement}
      className={wrapperClass}
      style={{ alignItems: "center" }}
    >        {isMobile &&  NewHeadline}
 
 <div className="controlVideoText">
      {!isMobile && (
        <div>
          <div
            className="reelTextTop"
            style={{   width:"230px"}}
          >
            <h3 className="color-blue-dark"  style={{ maxWidth: current?.maxTxtWidth  ,marginLeft:"auto"}}>{current?.headline}</h3>
            <p className="color-blue-dark" style={{ maxWidth: current?.maxTxtWidth ,marginLeft:"auto"}}>{current?.subtext}</p>
          </div>

          <div>
            {current?.small_regular && (
              <p className="color-blue-dark">{current.small_regular}</p>
            )}
            {current?.small_bold && (
              <p className="color-blue-dark" style={{ fontWeight: 700 }}>
                {current.small_bold}
              </p>
            )}
          </div>
        </div>
      )}
  
 
      <div>

     
        <motion.div
          className="videoScreenFrame"
          style={frameStyle}
          drag={dragEnabled ? "x" : false}
          dragConstraints={{ left: 0, right: 0 }}
          dragElastic={0.2}
          onDragStart={markInteractionThatShouldEnableSound}
          onDragEnd={(e, info) => {
            const threshold = 60;
            if (info.offset.x < -threshold) onSwipeNext();
            if (info.offset.x > threshold) onSwipePrev();
          }}
          whileTap={dragEnabled ? { scale: 0.995 } : undefined}
        >
          <video
            ref={videoRef}
            key={`${current.src}_${index}`}
            src={current.src}
            poster={current.poster}
            playsInline
            preload="metadata"
            muted={isMuted}
            controls={false}
            style={{
              width: "100%",
              height: isMobile ? "auto" : "100%",
              display: "block",
              objectFit: "contain", // ✅ בלי חיתוך
              background: "transparent",
            }}
            onLoadedMetadata={(e) => {
              const v = e.currentTarget;
              if (v.videoWidth && v.videoHeight) {
                setAspect(v.videoWidth / v.videoHeight); // ✅ רוחב נגזר מהגובה
              }
            }}
            onClick={() => {
              markInteractionThatShouldEnableSound();
              togglePlayPause();
            }}
          />

          {/* 🔴 BORDER OVERLAY – לא אוכל מידות */}
          <div
            aria-hidden="true"
            style={{
              position: "absolute",
              inset: 0,
              borderRadius: `${isMobile ? "22px" : "22px"} `,
              border: `${isMobile ? 4 : 5}px solid #1F3B51`,
              pointerEvents: "none",
              boxSizing: "border-box",
            }}
          />

          <VideoControls
            isPlaying={isPlaying}
            isMuted={isMuted}
            isVisible={isVisible}
            requiresUserRestartForSound={requiresUserRestartForSound}
            onPrev={() => {
              markInteractionThatShouldEnableSound();
              goPrev();
            }}
            onNext={() => {
              markInteractionThatShouldEnableSound();
              goNext();
            }}
            onPlayPause={() => {
              markInteractionThatShouldEnableSound();
              togglePlayPause();
            }}
            onToggleMute={toggleMute}
          />
        </motion.div>
      </div>

 
      {isMobile && (
        <div style={{ marginTop: "12px" }}>
          {current?.small_regular && (
            <p className="color-blue-dark">{current.small_regular}</p>
          )}
          {current?.small_bold && (
            <p className="color-blue-dark" style={{ fontWeight: 700 }}>
              {current.small_bold}
            </p>
          )}
        </div>
      )} 



 </div>




         {!isMobile &&  NewHeadline}
 
    </div>
  );
};

export default VideoScreen;
